import axios from "axios";
import tenantApiDomain from "@/helpers/TenantApiDomain";

export const Tenant = {
    async create_item(endpoint, data, params) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.post(`/${endpoint}`, data, { params });
        } catch (error) {
            throw error;
        }
        return response.data;
    },

    async get_options(endpoint) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.options(`/${endpoint}`);
        } catch (error) {
            throw error;
        }
        return response.data;
    },

    async get_item(endpoint, uuid, params) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.get(`/${endpoint}/` + uuid, { params });
        } catch (error) {
            throw error;
        }
        return response.data;
    },


    async get_items(endpoint, params) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.get(`/${endpoint}`, { params });
        } catch (error) {
            throw error;
        }
        return response.data;
    },

    async patch_item(endpoint, uuid, data, params) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.patch(`/${endpoint}/` + uuid, data, { params });
        } catch (error) {
            throw error;
        }
        return response.data;
    },

    async update_item(endpoint, uuid, data, params) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.put(`/${endpoint}/` + uuid, data, { params });
        } catch (error) {
            throw error;
        }
        return response.data;
    },

    async delete_item(endpoint, uuid) {
        axios.defaults.baseURL = `https://${tenantApiDomain()}`;
        let response;
        try {
            response = await axios.delete(`/${endpoint}/` + uuid);
        } catch (error) {
            throw error;
        }
        return response.data;
    }

};